import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import logo from "../../asses/img/parkingl.png";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import * as ROUTES from "../../constans/rutas";
import axios from "axios";
import { FaHome } from "react-icons/fa";
import { toast } from "react-toastify";
import InvoicePointService from "../../components/PointServiceInvoices";
import ElectronicInvoice from "../../components/ElectronicInvoice";
import { URL_EMPLOYEE } from "../../constans/servidor";

const ConsultInvoice = () => {
  const [numberInvoice, setNumberInvoice] = useState("");
  const [electronicInvoice, setElectronicInvoice] = useState("");
  const [prefijo, setPrefijo] = useState("");
  const [numberTicket, setNumberTicket] = useState("");
  const [codTerminal, setCodTerminal] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [transactionsElectronic, setTransactionsElectronic] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const [error, setError] = useState("");
  const [window, setwindow] = useState(1);
  const [searchType, setSearchType] = useState("electronicInvoice");
  const [searchValue, setSearchValue] = useState("");
  const [change, setChange] = useState(false);
  const history = useHistory();

  const handleChange = (e) => {
    setNumberInvoice(e.target.value);
    if (error) setError("");
  };

  const handleSearchValueChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleChangeInvoiceElectronic = (e) => {
    setElectronicInvoice(e.target.value);
    if (error) setError("");
  };

  const handleChangePrefijo = (e) => {
    setPrefijo(e.target.value.toUpperCase());
    if (error) setError("");
  };

  const handleSearchTypeChange = (e) => {
    setSearchType(e.target.value);
    if (error) setError();
  };

  const handleChangeTicket = (e) => {
    setNumberTicket(e.target.value);
    if (error) setError("");
  };

  const handleChangeCod = (e) => {
    setCodTerminal(e.target.value);
    if (error) setError("");
  };

  const onSubmit = async (e) => {
    setTransactions([]);
    e.preventDefault();
    setShowLoading(true);
    try {
      if (numberTicket) {
        let typeReceipt = "Skidata";
        const response = await axios.post(
          `${URL_EMPLOYEE}/parkingInvoiceOne/consutlInvoiceSAP`,
          {
            barcode: numberTicket,
            typeReceipt,
          }
        );

        if (response.data.status) {
          toast.success(response.data.message);
          setTransactions(response.data.data);
          setShowLoading(false);
        } else {
          setShowLoading(false);
          toast.error(response.data.message);
        }
      } else {
        if (!numberInvoice && !codTerminal) {
          console.log("No hay data!!");
          setError("Se requieren todos los campos");
          toast.error("Se requieren todos los campos");
          setShowLoading(false);
          return;
        }

        if (numberInvoice) {
          let typeReceipt = "Parking";
          const response = await axios.post(
            `${URL_EMPLOYEE}/parkingInvoiceOne/consutlInvoiceSAP`,
            {
              numberInvoice,
              codTerminal,
              typeReceipt,
            }
          );
          console.log(response.data)

          if (response.data.status) {
            toast.success(response.data.message);
            setTransactions(response.data.data);
            setShowLoading(false);
          } else {
            setShowLoading(false);
            toast.error(response.data.message);
          }
        }
      }
    } catch (error) {
      setShowLoading(false);
      console.log("ERROR:", error);
      toast.error("Hubo un error al consultar la transacción.");
    }
  };

  const searchElectronicInvoice = async (e) => {
    setTransactionsElectronic([]);
    e.preventDefault();
    setShowLoading(true);
    try {
      if (!electronicInvoice) {
        toast.error("Se requiere el numero de factura!");
        setShowLoading(false);
        return;
      }

      const response = await axios.post(
        `${URL_EMPLOYEE}/parkingInvoiceOne/graphicalRepresentation`,
        {
          numberInvoice: electronicInvoice,
          prefijo: prefijo 
        }
      );

      if (response.data.status && response.data.pdf64 !== "No existe PDF") {
        toast.success(response.data.message);
        setTransactionsElectronic(response.data);
        setShowLoading(false);
      } else {
        setShowLoading(false);
        toast.error(response.data.pdf64);
      }
    } catch (error) {
      showLoading(false);
      toast.error("Ocurrió un error al buscar la información.");
      console.error("Error al consumir el servicio:", error);
    }
  };

  const searchDetailInvoice = async (e) => {
    e.preventDefault();
    setShowLoading(true);
    setTransactions([]);
    console.log(searchType, searchValue);
    try {
      if (searchType === "document") {
        const response = await axios.post(
          `${URL_EMPLOYEE}/parkingInvoiceOne/consultInformationID`,
          {
            document: searchValue,
          },
          {
            timeout: 60000,
          }
        );

        console.log("status: ", response.data.status);

        if (response.data.status) {
          toast.success(response.data.message);
          setTransactions(response.data.data);
          setShowLoading(false);
        } else {
          setShowLoading(false);
          toast.error(response.data.message);
        }
      } else if (searchType === "plate") {
        const response = await axios.post(
          `${URL_EMPLOYEE}/parkingInvoiceOne/consultInformationID`,
          {
            plate: searchValue,
          },
          {
            timeout: 60000,
          }
        );

        if (response.data.status) {
          toast.success(response.data.message);
          setTransactions(response.data.data);
          setShowLoading(false);
        } else {
          setShowLoading(false);
          toast.error(response.data.message);
        }
      } else {
        toast.error("Se requiere un documento o placa para la busqueda!");
        setShowLoading(false);
        return;
      }
    } catch (error) {
      showLoading(false);
      if (error.code === "ECONNABORTED") {
        toast.error("La solicitud excedió el tiempo de espera (60 segundos).");
      } else {
        toast.error("Ocurrió un error al buscar la información.");
      }
      console.error("Error al consumir el servicio:", error);
    }
  };

  return (
    <>
      <Container className="contendor-Principal">
        <Row>
          <Col className="cont_logo" xs={12} sm={12} md={12} lg={12} xl={12}>
            <img className="logo" src={logo}></img>
            <p className="texto-slogan">
              Gestion de Facturas Puntos de Servicio
            </p>
          </Col>
        </Row>
        <Row className="justify-content-end ">
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "15px",
            }}
            className="cont_logo"
            xs={12}
            sm={12}
            md={6}
            lg={4}
            xl={4}
          >
            <Button
              style={{ marginRight: "10px" }}
              variant="primary"
              onClick={() => history.push(ROUTES.HOME)}
            >
              <FaHome size={20} style={{ marginRight: "5px" }} />
              HOME
            </Button>
          </Col>
        </Row>
        <Row className="justify-content-end mbottom-20 menu">
          <Col
            className={window === 1 ? "menu_items2" : "menu_items"}
            xs={2}
            sm={2}
            md={2}
            lg={2}
            xl={2}
          >
            <button
              onClick={() => {
                setwindow(1);
                setTransactions([]);
                setNumberTicket("");
                setNumberInvoice("");
                setCodTerminal("");
                setSearchValue("");
              }}
            >
              Facturas Parking
            </button>
          </Col>
          <Col
            className={window === 2 ? "menu_items2" : "menu_items"}
            xs={4}
            sm={4}
            md={2}
            lg={2}
            xl={2}
          >
            <button
              onClick={() => {
                setwindow(2);
                setTransactions([]);
                setNumberInvoice("");
                setCodTerminal("");

                setSearchValue("");
              }}
            >
              Facturas Skidata
            </button>
          </Col>
          <Col
            className={window === 3 ? "menu_items2" : "menu_items"}
            xs={2}
            sm={2}
            md={2}
            lg={2}
            xl={2}
          >
            <button
              onClick={() => {
                setwindow(3);
                setTransactions([]);
                setElectronicInvoice("");
                setPrefijo("");
                setNumberTicket("");
                setCodTerminal("");
                setTransactionsElectronic("");

                setSearchValue("");
              }}
            >
              Factura Electrónica
            </button>
          </Col>
          <Col
            className={window === 4 ? "menu_items2" : "menu_items"}
            xs={2}
            sm={2}
            md={2}
            lg={2}
            xl={2}
          >
            <button
              onClick={() => {
                setwindow(4);
                setTransactions([]);
                setElectronicInvoice("");
                setPrefijo("");
                setNumberTicket("");
                setCodTerminal("");
                setTransactionsElectronic("");

                setSearchValue("");
              }}
            >
              Consulta Rápida
            </button>
          </Col>
        </Row>
      </Container>
      <Container>
        {window === 1 ? (
          <>
            <Row className="justify-content-center mbottom-20">
              <div>
                <Form onSubmit={onSubmit}>
                  <Form.Group className="form-group" controlId="formBasicEmail">
                    <Form.Control
                      className="form-control-admin"
                      type="text"
                      value={numberInvoice}
                      placeholder="Numero de comprobante"
                      onChange={handleChange}
                    />
                    {error && (
                      <div className="error-message" style={{ color: "red" }}>
                        {error}
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group className="form-group" controlId="formBasicEmail">
                    <Form.Control
                      className="form-control-admin"
                      type="text"
                      value={codTerminal}
                      placeholder="Terminal"
                      onChange={handleChangeCod}
                    />
                    {error && (
                      <div className="error-message" style={{ color: "red" }}>
                        {error}
                      </div>
                    )}
                  </Form.Group>
                  {showLoading ? (
                    <div className="container-sniper"></div>
                  ) : (
                    <Button variant="primary" type="submit">
                      Buscar
                    </Button>
                  )}
                </Form>
                {transactions.length ? (
                  <>
                    <InvoicePointService filteredData={transactions} />
                  </>
                ) : null}
              </div>
            </Row>
          </>
        ) : null}
        {window === 2 ? (
          <>
            <Row className="justify-content-center mbottom-20">
              <div>
                <Form onSubmit={onSubmit}>
                  <Form.Group className="form-group" controlId="formBasicEmail">
                    <Form.Control
                      className="form-control-admin"
                      type="text"
                      value={numberTicket}
                      placeholder="Numero de Ticket"
                      onChange={handleChangeTicket}
                    />
                    {error && (
                      <div className="error-message" style={{ color: "red" }}>
                        {error}
                      </div>
                    )}
                  </Form.Group>
                  {showLoading ? (
                    <div className="container-sniper"></div>
                  ) : (
                    <Button variant="primary" type="submit">
                      Buscar
                    </Button>
                  )}
                </Form>
                {transactions.length ? (
                  <>
                    <InvoicePointService filteredData={transactions} />
                  </>
                ) : null}
              </div>
            </Row>
          </>
        ) : null}
        {window === 3 ? (
          <>
            <Row className="justify-content-center mbottom-20">
              <div>
                <Form onSubmit={searchElectronicInvoice}>
                  <Form.Group className="form-group" controlId="formBasicEmail">
                    <Form.Control
                      className="form-control-admin"
                      type="text"
                      value={electronicInvoice}
                      placeholder="Factura Electrónica"
                      onChange={handleChangeInvoiceElectronic}
                    />
                    {error && (
                      <div className="error-message" style={{ color: "red" }}>
                        {error}
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group className="form-group" controlId="formBasicEmail">
                    <Form.Control
                      className="form-control-admin"
                      type="text"
                      value={prefijo}
                      placeholder="Prefijo"
                      onChange={handleChangePrefijo}
                    />
                    {error && (
                      <div className="error-message" style={{ color: "red" }}>
                        {error}
                      </div>
                    )}
                  </Form.Group>
                  {showLoading ? (
                    <div className="container-sniper"></div>
                  ) : (
                    <Button variant="primary" type="submit">
                      Buscar
                    </Button>
                  )}
                </Form>
                {transactionsElectronic.status ? (
                  <>
                    <ElectronicInvoice
                      filteredData={transactionsElectronic}
                      numberInvoice={electronicInvoice}
                      prefijo={prefijo}
                    />
                  </>
                ) : null}
              </div>
            </Row>
          </>
        ) : null}
        {window === 4 ? (
          <>
            <Row className="justify-content-center mbottom-20">
              <div>
                <Form onSubmit={searchDetailInvoice}>
                  <Form.Group
                    className="form-group"
                    controlId="selectSearchType"
                  >
                    <Form.Control
                      as="select"
                      className="form-control-admin"
                      value={searchType}
                      onChange={handleSearchTypeChange}
                    >
                      <option value="electronicInvoice">
                        Tipo de Búsqueda
                      </option>
                      <option value="document">Documento</option>
                      <option value="plate">Placa</option>
                    </Form.Control>
                  </Form.Group>

                  <Form.Group
                    className="form-group"
                    controlId="formBasicSearch"
                  >
                    <Form.Control
                      className="form-control-admin"
                      type="text"
                      value={searchValue}
                      placeholder={
                        searchType === "electronicInvoice"
                          ? ""
                          : searchType === "document"
                            ? "Documento de Identidad"
                            : "Plate"
                      }
                      onChange={handleSearchValueChange}
                    />
                    {error && (
                      <div className="error-message" style={{ color: "red" }}>
                        {error}
                      </div>
                    )}
                  </Form.Group>
                  {showLoading ? (
                    <div className="container-sniper"></div>
                  ) : (
                    <Button variant="primary" type="submit">
                      Buscar
                    </Button>
                  )}
                </Form>
                {transactions.length ? (
                  <>
                    <InvoicePointService filteredData={transactions} />
                  </>
                ) : null}
              </div>
            </Row>
          </>
        ) : null}
      </Container>
    </>
  );
};

export default ConsultInvoice;
